import Vue from "vue";
import Vuex from "vuex";
import Cookies from 'js-cookie';
import axios from 'axios'
import urlConfig from './url';
import http from '../utils/http.js'
import { getToken, setToken, removeToken,setUserInfo,getUserInfo,removeUserInfo } from './utils/auth'
Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		userInfo: getUserInfo(),
		token: getToken(),
		isRole:false,
		newsNum:0
	},
	mutations: {
		SET_USERINFO: (state, userinfo) => {
			state.userInfo = userinfo
		},
		SET_TOKEN: (state, token) => {
		  state.token = token
		},
		SET_Role: (state, isRole) => {
		  state.isRole = isRole
		},
		SET_NEWSNUM: (state, newsNum) => {
		  state.newsNum = newsNum
		},
	},
	actions: {
		// 登录
		Login({ commit }, userInfo) {
		 return new Promise((resolve, reject) => {
			http.post(`${urlConfig.devUrl}apij2/admin-api/system/user/login`,userInfo)
			  .then(res => {
			    const data = res.data;
					console.log(data)
			     setToken(data.id)
				 commit('SET_TOKEN', data.id)
				 setUserInfo(JSON.stringify(data))
				 commit('SET_USERINFO', JSON.stringify(data));
				  resolve()
			  })
			  .catch(error => {reject(error)}); 
		  })
		},
		// 退出
		logout({
			commit
		}, id) {
			return new Promise((resolve, reject) => {
				http.post(`${urlConfig.devUrl}apij2/admin-api/system/user/logout`)
					.then(res => {
						commit('SET_USERINFO', '');
						commit('SET_TOKEN', '')
						removeToken()
						removeUserInfo()
						resolve()
					}).catch(error => {
						reject(error)
					})
			});
		},
		// 是否登录
		isLogin({
			commit
		}, id) {
			return new Promise((resolve, reject) => {
				http.get(`${urlConfig.devUrl}apij2/admin-api/system/user/is_login?id=${id}`)
					.then(res => {
						resolve(res)
					}).catch(error => {
						reject(error)
					})
			})
		},
		//获取所有组织架构人员信息
		getUser({commit}){
			return new Promise((resolve, reject) => {
				http.post(`${urlConfig.devUrl}apij2/admin-api/system/user/page`, {
					type: 2,
					all: 1
				})
					.then(res => {
						resolve(res)
					}).catch(error => {
						reject(error)
					})
			})
		},
		//监控编辑角色
		setRole({commit},value){
			  commit("SET_Role", value)
		},
		// 获取消息数量
		getnewsList({commit}){
			http.get(urlConfig.devUrl+'apij2/admin-api/finance/mail/getUnReadNum')
					.then(res => {
						commit("SET_NEWSNUM", res.data)
					}).catch(error =>{
						console.log(error);
					})
		}
	},
	getters: {
		userInfo: state => {
			return state.userInfo
		},
		token: state => {
			return state.token
		},
		isRole:state => {
			return state.isRole
		},
		newsNum:state =>{
			return state.newsNum
		}
	}
});
